import axiosInstance from "../../core/axios";
import { saveSession } from "../sos_2026/service";
import { LEAD_EVENT } from "./content";

/* Mesmo fluxo do formulário do Craques do Enem (components/ModalLead):
 * salva o aluno no navegador, que já vale como login nos simulados, e
 * registra o lead em /leads e /dashboard/lp. Falha nessas chamadas não
 * trava a inscrição (igual ao Craques). */
export async function registrarInscricao({ nome, email, whatsapp, objetivo }) {
  const user = saveSession({ name: nome, email, whatsapp });

  await Promise.all([
    axiosInstance
      .post("/leads", { name: user.name, email: user.email, tel: user.whatsapp, event: LEAD_EVENT })
      .catch((e) => console.error(e)),
    axiosInstance
      .post("/dashboard/lp", {
        name: user.name,
        email: user.email,
        phone: user.whatsapp,
        url: window.location.href,
        additionalParams: { event: LEAD_EVENT, objetivo },
      })
      .catch((e) => console.error(e)),
  ]);
}
